import React from 'react';
import './App.css';
import 'papercss/dist/paper.css'
import FlipMove from "react-flip-move";
import { SortableItem, swapArrayPositions } from "react-sort-list";



let App = (props)=>{
    
    return (
        <div className="styled">
            <div >
            <Todolist list={[{name:"first",status:true,deadline:"-"}]}></Todolist>
        </div>
        </div>
        )
}

class Todolist extends React.Component{

    constructor(props){
        super(props);
        this.state={};
        this.state.list=props.list; 
        this.state.item=''; 
        this.state.isEditing=false;

    }

    getlist(event){
        this.setState({item:event.target.value})
    }
    getdate(event){
        this.setState({deadline:event.target.value})
    }
    // setdate(event){
    //     this.setState({date:event.target.value})
    // }
    // settime(event){
    //     this.setState({time:event.target.value})
    // }

    set(e){
        let l=this.state.list;
        if(this.state.item!==''){
            let obj={name:this.state.item,status:false,deadline:this.state.deadline,date:new Date().toLocaleString()}
            console.log("date",obj);
            
            l.push(obj)
        }
        // console.log("deadline",this.state.deadline)
        // console.log('new list',l)
        this.setState({list:l,item:''}) 
    }


    //  Edit(){
    //     let  l=this.state.list
    //     const {isEditing}=this.state
    //      this.setState({
    //          isEditing :!isEditing ,list:l
    //      })
    //     }

       
    
    setlist(){
        let l = [];         
     
        for (let item of this.state.list){
            if(item.deadline!==undefined){
                var de=item.deadline,dea=de.slice(8,10),deam=de.slice(5,7),deay=de.slice(0,4)
                console.log("item.deadline ninob",de,dea,deam,deay)
            }
            
            const d=new Date();
           
            l.push(
                
            <div class="row flex-center">
                <button class="btn-success" onClick={()=>this.Swapup(item)} >UP</button>
                <button class="btn-warning" onClick={()=>this.Swapdown(item)}>DOWN</button>
                <div class="col-6 col">
    
                    {/* {isEditing?<form class="row flex-center">
                        <input type="text"/>
                        <button onClick={(e)=>this.set(e)} >update item</button>
                        </form>: */}
                <li class="h" onClick={()=>(this.changestatus(item)) }  className={item.status?"paper-btn btn-block btn-success":"paper-btn btn-block btn-warning"} >
                {item.name}<span className="dat">{item.date}</span>
                
                </li>
                
                <label class="d" 
                className={((dea-d.getDate())<2 && (deam-(d.getMonth()+1))===0 && (deay-(d.getFullYear()))===0)
                ?"badge danger":"badge warning"}>

                DEADLINE:-{item.deadline}
                    
                    {console.log("item.deadline",item.deadline,d.getDate(),d.getMonth()+1,d.getFullYear(),dea,deam,deay)}
                </label>
                </div>
                <button class="btn-danger" onClick={()=>this.del(item)}>X</button>
                {/* <button class="btn-secondary" onClick={()=>this.Edit()}>Edit</button> */}
                <button class="btn-danger" onClick={()=>this.upp(item)}>Pin</button>
            </div>)
        }
        return l; 
    }

    upp(item){
         let i=this.state.list.indexOf(item)
         let l=this.state.list
         let m=[];
         if(i!==0){
             m[0]=l[i];
            for(let j=1;j<=i;j++){
                     m[j]=l[j-1];
                 }
            for(let j=(i+1);j<l.length;j++){
                m[j]=l[j];
            }     
        }
        this.setState({list:m})
     }

    Swapup(item){
        
        let i=this.state.list.indexOf(item)
        let l=this.state.list
        if(i!==0){
        let x=l[i];
        l[i]=l[i-1];
        l[i-1]=x;
        }
        
        this.setState({list:l})
    }
    
    Swapdown(item){

        let i=this.state.list.indexOf(item)
        let l=this.state.list;
        let x=l[i];
        let n=l.length;
        if(i!==(n-1)){
        l[i]=l[i+1];
        l[i+1]=x;
        }
        this.setState({list:l})
    }
    
    changestatus(item){
        console.log("item",item);
        let i=this.state.list.indexOf(item)
        let l=this.state.list;
        l[i].status=!l[i].status;
        this.setState({list:l})
    }

    del(item){

        let i=this.state.list.indexOf(item)
        let l=this.state.list;
        let x=l.splice(i,1)
        console.log("x",x)
        this.setState({list:l})
    }

    count(e){
        let l=this.state.list;
        let c=0;
        for(let item in l){
            if(l[item].status===true){
                c++;  
            }
        }
      return c; 
    }
    
    // order(event){
    //     console.log("event",event.target.value);
    //     let l=this.state.list;
    //     let x=l.sort((a,b) => (a.last_nom> b.last_nom) ? 1 : ((b.last_nom > a.last_nom) ? -1 : 0));
    //     this.setState({list:x})
    // }

    render(){;
        let x=(this.count()/this.state.list.length)*100
        let n=x.toFixed(0)
        console.log(x,n)
        
        return(
            
        <div>
            <h3 class="row flex-center"><span class="badge danger">TO_DO_LIST</span></h3>
            <div class="row flex-center">
                <div class="col-8 col">
                    <input placeholder="Enter task" class="i" onChange={(event)=>this.getlist(event)} type="text" value={this.state.item}></input>
                   
                <input type="date" class="date" onChange={(event)=>this.getdate(event)}/>
                    
                <label class="badge">Enter deadline</label>
                </div>
                <div class="col-2 col" >
                    <button className="btn-success" class="b" onClick={(e)=>this.set(e)}>ADD</button></div>
                {/* <div class="col-2 col">


                    <select onChange={(e)=>this.order(e)} > 
                    <option value="select">Select</option>      
                        <option value="date">Date</option>                        
                        <option value="name">name</option>
                        <option value="completed">Completed Items</option>
                    </select></div> */}


           </div>
             
           <h4 class="row flex-center">Completed items {this.count()}/{this.state.list.length}</h4> 
           <div class="progress margin-button">
               <div class={"bar striped success w-"+(n)}></div>
           </div>
            <ul>
              <FlipMove duration={500} easing="ease-out">
              {this.setlist()}
            </FlipMove> 
            </ul> 
        </div>)
    }
}
export default App;